import { FC } from "react";
import { CMS, ContentfulEntryType } from "utils/types";
import ResourceCard from "../../shared/ResourceCard";
import formatDollar from "utils/formatDollar";

interface RenderResourceCardProps {
	resource: CMS.CMSResource;
	index: number;
	mobileLoadMore?: boolean;
	variant?: "vertical" | "horizontal" | "featured";
}

const RenderResourceCard: FC<RenderResourceCardProps> = ({
	resource,
	index,
	mobileLoadMore = false,
	variant = "vertical",
}) => {
	let type: ContentfulEntryType;
	switch (true) {
		case resource.tags.includes("Case Studies"):
			type = "casestudy";
			break;
		case resource.tags.includes("Blog Posts"):
			type = "blog";
			break;
		case resource.tags.includes("Insights"):
			type = "insight";
			break;
		default:
			type = "blog";
	}

	const href = resource.tags.includes("Case Studies")
		? resource.tags.includes("Commercial")
			? `/commercial-case-study/${encodeURIComponent(resource.slug)}`
			: `/case-study/${encodeURIComponent(resource.slug)}`
		: resource.tags.includes("Insights")
			? `/insight/${encodeURIComponent(resource.slug)}`
			: `/blog/${encodeURIComponent(resource.slug)}`;

	const imgUrl = resource.heroImage?.fields?.file?.url;
	const publishedAt = resource.createdAt;
	const description = resource.subtitle;

	const savings = (resource as CMS.CommercialCaseStudyFields).taxBillSavings
		? formatDollar((resource as CMS.CommercialCaseStudyFields).taxBillSavings)
		: "";

	return (
		<ResourceCard
			key={resource.slug + index}
			type={type}
			id={resource.slug}
			href={href}
			img={imgUrl}
			savings={savings}
			date={publishedAt}
			title={resource.title}
			description={description}
			style={mobileLoadMore ? { display: "block" } : {}}
			variant={variant}
			tags={resource.tags}
		/>
	);
};

export default RenderResourceCard;
